import { createClient } from '@/shared/api';
import type { GetEcgDataMapQuery, GetEcgDataMapQueryVariables } from '@/shared/api';
import GET_ECG_DATA_MAP_QUERY from '../queries/getEcgDataMap';

/**
 * Loads the ECG data map describing which signal ranges exist for a study. Runs GET_ECG_DATA_MAP_QUERY and throws getEcgDataMap.message when isSuccess is false, otherwise returning the ecgDataMap payload.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @returns The ECG data map for the requested window.
 */
const fetchEcgDataMap = async (
  filter: GetEcgDataMapQueryVariables['filter'],
): Promise<GetEcgDataMapQuery['getEcgDataMap']['ecgDataMap']> => {
  const client = createClient();
  const ecgDataMapResult = await client.query<GetEcgDataMapQuery, GetEcgDataMapQueryVariables>({
    query: GET_ECG_DATA_MAP_QUERY,
    variables: {
      filter,
    },
  });
  const { data } = ecgDataMapResult;
  const { getEcgDataMap } = data;
  if (!getEcgDataMap.isSuccess) {
    throw new Error(getEcgDataMap.message ?? undefined);
  }
  return getEcgDataMap.ecgDataMap;
};

export default fetchEcgDataMap;
